import { onMount } from 'solid-js';

type Props = {
	slug: string;
};

export const READING_HISTORY_KEY = 'akashrajpurohit.com::reading_history';

export default function ReadingHistory(props: Props) {
	onMount(() => {
		try {
			const readingHistory = JSON.parse(
				localStorage.getItem(READING_HISTORY_KEY) || '[]',
			);

			if (!readingHistory.includes(props.slug)) {
				readingHistory.push(props.slug);
				localStorage.setItem(
					READING_HISTORY_KEY,
					JSON.stringify(readingHistory),
				);
			}
		} catch (error) {
			console.error('Error tracking reading history:', error);
		}
	});

	return null;
}
